import React from "react";

import { Auth } from "../../../context/admin/Authentication";

import Screen from "../../home/content/Screen";

import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { DoSeeDataProvider } from "../../../context/doSeeData/DoSeeDataContext";
import { CountryProvider } from "../../../context/country/countryContext/CountryContext";
import { PositionProvider } from "../../../context/position/PositionContext";

export const ThingsToDo = () => {
  return (
    <DoSeeDataProvider>
      <PositionProvider>
        <Auth
          children={
            <Screen
              component={<Overview />}
              title="Things To Do"
            />
          }
        />
      </PositionProvider>
    </DoSeeDataProvider>
  );
};

export const AddThingsToDo = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Add />}
              title="Add Things To Do"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};

export const EditThingsToDo = () => {
  return (
    <CountryProvider>
      <DoSeeDataProvider>
        <Auth
          children={
            <Screen
              component={<Edit />}
              title="Edit Things To Do"
            />
          }
        />
      </DoSeeDataProvider>
    </CountryProvider>
  );
};
